import { createFileRoute } from "@tanstack/react-router"

import { Stack } from "@chakra-ui/react"
import { useEffect } from "react"
import Signature from "../components/Signature"
import useFrame from "../hooks/useFrame"

interface SignatureParameters {
  orderid: string
}
const SignRoute: React.FC = () => {
  const { containerRef, sendHeight } = useFrame()
  const orderId = Route.useSearch({
    select: (search) => search.orderid ?? "",
  })

  useEffect(() => {
    sendHeight()
  }, [sendHeight])

  return (
    <>
      <Stack ref={containerRef}>
        <Signature orderId={orderId} />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/signature")({
  component: SignRoute,
  validateSearch: (search: Record<string, unknown>): SignatureParameters => {
    return {
      orderid: (search.orderid as string) || "",
    }
  },
})
